import React, { ReactElement } from "react";
import { ParticularsProps } from "../../types/Particulars";
import { Trans } from "react-i18next";
import "./Particulars.css";

const renderGridItem = (particular: [string, string | undefined]) => (
    <div key={particular[0]} className="col-12 sm:col-6 md:col-4">
        <small className="particulars-header">
            <Trans
                ns="common"
                i18nKey={`inspectionReport.particulars.${particular[0]}`}
            />
        </small>
        <p className="particulars-value" data-cy={particular[0].toLowerCase()}>
            {particular[1]}
        </p>
    </div>
);

export const Particulars = (props: ParticularsProps): ReactElement => {
    const particulars = props.particulars;

    return (
        <div className="grid">
            {Object.entries(particulars).map(renderGridItem)}
        </div>
    );
};
